import clsx from "clsx";

import translate from "../../locales";

export function ContinueCard({
  img,
  title,
  description,
  labelNext,
  buttonNextDisabled,
  onClick,
}) {
  return (
    <div className={clsx("cta")}>
      {typeof img === "string" ? (
        <img className={clsx("icon")} alt="" src={img} />
      ) : (
        <div className={clsx("icon")}>{img}</div>
      )}
      <div className={clsx("text")}>
        <p className={clsx("subtitle")}>{translate(title)}</p>
        <p className={clsx("description")}>{translate(description)}</p>
      </div>
      <div className={clsx("spacer")} />
      <button
        className={clsx("button")}
        disabled={buttonNextDisabled}
        onClick={onClick}
      >
        {translate(labelNext)}
      </button>
    </div>
  );
}
